const initialState = {
    days: [],
    sports: {},
    events: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
    case 'FETCH_SCHEDULE_SUCCESS':
        return { ...state,
            events: { ...action.events },
            days: [...action.days],
            sports: { ...action.sports }
        };
    case 'TOGGLE_SCHEDULE_SLIDER_CARD':
        return { ...state,
            events: { ...state.events,
                [action.id]: { ...state.events[action.id], isOpen: !state.events[action.id].isOpen }
            }
        };
    case 'TOGGLE_SCHEDULE_SLIDER_DAY':
        return {
            ...state,
            days: state.days.map((day) => {
                if (day.id === action.id) {
                    return { ...day, isOpen: !day.isOpen };
                }
                return day;
            })
        };
    case 'CLOSE_ALL_DAYS': {
        const daysResult = state.days.map(item => ({ ...item, isOpen: false }));
        const newsState = { ...state, days: daysResult };
        return newsState;
    }
    case 'SHOW_SCHEDULE_DAY_CARD': {
        const sport = action.sportName;
        const date = action.date;
        return { ...state,
            sports: { ...state.sports,
                [sport]: { ...state.sports[sport],
                    [date]: {
                        ...state.sports[sport][date],
                        showCard: true
                    }
                }
            }
        };
    }
    case 'CLOSE_SCHEDULE_DAY_CARD': {
        const sport = action.sportName;
        const date = action.date;
        return { ...state,
            sports: { ...state.sports,
                [sport]: { ...state.sports[sport],
                    [date]: {
                        ...state.sports[sport][date],
                        showCard: false
                    }
                }
            }
        };
    }
    case 'CLOSE_ALL_SCHEDULE_DAY_CARD': {
        const newState = { ...state };
        Object.keys(newState.sports).forEach((sportName) => {
            const sport = newState.sports[sportName];
            Object.keys(sport).forEach((date) => {
                if (sport[date].showCard) {
                    sport[date].showCard = false;
                }
            });
        });
        return newState;
    }
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/schedule.reducer.js